export const constante={
 'vtp': 'Véhicules particuliers ou de tourisme' ,
 'vct' : 'Véhicules de commerce TPPC',
 'vtpm' : 'Véhicules de transports publics de marchandises',
 'vdr' : 'Véhicules à deux roues',
 'vc' : 'Véhicules de chantier',
 'vu' : 'Véhicules utilitaires',
 'tcomp' : "''Tierce complète''",
 'tcol' : "''Tierce collision''"
}